import { createFileRoute } from '@tanstack/react-router';

import { LogoContainer } from '@/features/settings/containers/logo';

export const Route = createFileRoute('/_layout/settings/_layout/logo/')({
  component: LogoContainer,
});
